import { ESPageLoadingIndicator, RefetchOnError } from '@energy-stacks/shared';
import { TransactionsV21 } from './TransactionsV21';
import { useTransactionsV21 } from './useTransactionsV21';

export const ChargingStationDetailsTransactionsTabV21 = () => {
  const { isSuccess, isError, isLoading, refetch } = useTransactionsV21();

  return (
    <>
      {isLoading ? <ESPageLoadingIndicator /> : null}
      {isError ? <RefetchOnError onRefetch={refetch} /> : null}
      {isSuccess ? <TransactionsV21 /> : null}
    </>
  );
};
